export default "__VITE_ASSET___I6hgsNO__"